import { Card, Grid } from "@mui/material";
import TextFieldControl from "components/form/TextFieldControl";
import VALIDATION from "helpers/validation";

const TitleBlock = () => {
  return (
    <Card sx={{ p: 1.5 }}>
      <Grid
        container
        spacing={2}>
        <Grid
          item
          xs={12}
          md={6}>
          <TextFieldControl
            label='Название карты компетенций'
            name='title'
            rules={{ required: true, ...VALIDATION.competencyMapTitle }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}>
          <TextFieldControl
            label='Специализация'
            name='specialization'
            rules={{ required: true, ...VALIDATION.competencyMapTitle }}
          />
        </Grid>
      </Grid>
    </Card>
  );
};

export default TitleBlock;
